import { IconBed, IconPencil, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { RowActions } from 'src/Components/Shared/RowActions';

import styles from './BedItem.module.scss';
import { Props } from './BedItem.types';

const BedItem = ({ bed, onEdit, onDelete }: Props) => {
  const { t } = useTranslation();
  const hasDimensions = bed.widthCm != null && bed.lengthCm != null;

  return (
    <div className={styles.row}>
      <IconBed size={20} className={styles.icon} />
      <div className={styles.body}>
        <span className={styles.title}>
          {t(`admin.structure.bedTypes.${bed.type}`, bed.type)}
          {bed.label && <span className={styles.label}> · {bed.label}</span>}
        </span>
        <div className={styles.metaRow}>
          {hasDimensions && (
            <span>
              {t('admin.structure.beds.dimensions', {
                width: bed.widthCm,
                length: bed.lengthCm,
              })}
            </span>
          )}
          <span className={styles.capacity}>
            {t('admin.structure.beds.capacity', {
              count: bed.capacity,
              defaultValue: '{{count}} personne',
              defaultValue_other: '{{count}} personnes',
            })}
          </span>
        </div>
      </div>

      <RowActions
        actions={[
          {
            key: 'edit',
            label: t('common.edit', 'Modifier'),
            icon: <IconPencil size={18} />,
            onClick: () => onEdit(bed),
          },
          {
            key: 'delete',
            label: t('common.delete', 'Supprimer'),
            icon: <IconTrash size={18} />,
            variant: 'danger',
            onClick: () => onDelete(bed),
          },
        ]}
      />
    </div>
  );
};

export default BedItem;
